import React, { useEffect } from 'react';
import { useDisclose } from '../../../Modal/Hooks/useDisclose';
import styles from './UserSettingsButton.module.scss';
import Tooltip from '../../../../Components/Popup/Tooltip';
import Text from '../../../../Components/Base/Text/Text';
import UserSettingsWrapperModal from './UserSettingsWrapperModal';
import LocalStorage from '../../../../Services/LocalStorage';
import { LocalStorageKey } from '../../../Base/Enums/LocalStorageKey.enum';

interface Props {
	userId: string;
}

const UserSettingsButton: React.FC<Props> = ({ userId }) => {
	const { onOpen, isOpen, onClose } = useDisclose();

	useEffect(() => {
		// CHECK IF MODAL SHOULD OPEN AUTOMATICALLY
		if (LocalStorage.get(LocalStorageKey.OPEN_USER_SETTINGS)) {
			onOpen();
			// AFTER AUTOMATIC OPEN OF SETTINGS MODAL DISABLE AUTOMATIC OPEN FUNCTION
			LocalStorage.set(LocalStorageKey.OPEN_USER_SETTINGS, false);
		}
	}, []);

	return (
		<div className={styles.wrapper}>
			<Tooltip
				trigger={
					<div onClick={onOpen} className={styles.toggleButton}>
						<img
							width='42px'
							src='/dist/icons/settings-complete.svg'
							alt='wheel'
						/>
					</div>
				}>
				<Text tx={'base.settings'} />
			</Tooltip>
			{isOpen && (
				<UserSettingsWrapperModal userId={userId} isOpen onClose={onClose} />
			)}
		</div>
	);
};

export default UserSettingsButton;
